module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    class: ['info-box', _vm.colorClass]
  }, [_c('span', {
    staticClass: "info-box-icon"
  }, [_c('i', {
    class: _vm.iconClasses
  })]), _vm._v(" "), _c('div', {
    staticClass: "info-box-content"
  }, [_c('span', {
    staticClass: "info-box-text"
  }, [_vm._v(_vm._s(_vm.text))]), _vm._v(" "), _c('span', {
    staticClass: "info-box-number"
  }, [_vm._v(_vm._s(_vm.number))]), _vm._v(" "), _c('div', {
    staticClass: "progress"
  }, [_c('div', {
    staticClass: "progress-bar",
    style: ({
      width: _vm.progress + '%'
    })
  })]), _vm._v(" "), _c('span', {
    staticClass: "progress-description"
  }, [_vm._v(_vm._s(_vm.description))])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-404468b4"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/widgets/ProcessInfoBox.vue
// module id = 1338
// module chunks = 1